<div mat-dialog-title>
  <span>
    {{ 'EDITOR.GENERATE_BUSINESS_REQUIREMENTS' | translate }}
  </span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content>
  <p class="info-message">{{ 'REQUIREMENTS_GENERATION.INFO_MESSAGE' | translate }}</p>
  <form [formGroup]="generateRequirementsForm" #form="ngForm">
    <q9-custom-fields-form
      [onlyRequired]="true"
      [itemType]="changesType.REQUIREMENTS"
      [formGroup]="customFieldsFormGroup"></q9-custom-fields-form>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button [mat-dialog-close]="false">
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>

  <q9-primary-button (click)="form.onSubmit($event); onSubmit()">
    {{ 'GPT_STORIES.GENERATE_SUBMIT' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
